export default [
  {
    path: '/pay/cashierFee',
    name: 'cashierFee',
    meta: {
      title: '收银台'
    },
    component: () => System.import('@/PagesAreaScan/cashier/cashierFee')
  },
  {
    path: '/pay/cashier/transfer',
    name: 'transfer',
    meta: {
      title: '支付'
    },
    component: () => System.import('@/PagesAreaScan/cashier/transferAli')
  },
  {
    path: '/pay/browserPay',
    name: 'browserPay',
    meta: {
      title: '收银台'
    },
    component: () => System.import('@/PagesAreaScan/cashier/browserPay')
  },
  {
    path: '/scan/evaluate/:rentOrderId/history/:sourceType(1)',
    meta: {
      title: '我的评价'
    },
    component: () => System.import('@/PagesAreaScan/evaluate/history')
  },
  {
    path: '/scan/evaluate/:rentOrderId/history/:sourceType(2)',
    meta: {
      title: '我的评价'
    },
    component: () => System.import('@/PagesAreaScan/evaluateV2/history')
  },
  {
    path: '/scan/evaluate/:rentOrderId/history',
    meta: {
      title: '我的评价'
    },
    component: () => System.import('@/PagesAreaScan/evaluateV2/history')
  },
  {
    path: '/scan/evaluate/:rentOrderId/:sourceType(1)',
    meta: {
      title: '发表评价'
    },
    component: () => System.import('@/PagesAreaScan/evaluate/create')
  },
  {
    path: '/scan/evaluate/:rentOrderId/:sourceType(2)',
    meta: {
      title: '发表评价'
    },
    component: () => System.import('@/PagesAreaScan/evaluateV2/create')
  },
  {
    path: '/scan/evaluate/:rentOrderId',
    meta: {
      title: '发表评价'
    },
    component: () => System.import('@/PagesAreaScan/evaluateV2/create')
  },
  {
    path: '/scan/evaluate/:rentOrderId/success/:sourceType(1)',
    meta: {
      title: '感谢评价'
    },
    component: () => System.import('@/PagesAreaScan/evaluate/success')
  },
  {
    path: '/scan/evaluate/:rentOrderId/success/:sourceType(2)',
    meta: {
      title: '感谢评价'
    },
    component: () => System.import('@/PagesAreaScan/evaluateV2/success')
  },
  {
    path: '/scan/evaluate/:rentOrderId/success',
    name: 'scanEvaluateV2Success',
    meta: {
      title: '感谢评价'
    },
    component: () => System.import('@/PagesAreaScan/evaluateV2/success')
  },
  {
    path: '/pay/success',
    name: 'paySuccess',
    meta: {
      title: '支付成功'
    },
    component: () => System.import('@/PagesAreaScan/cashier/success')
  },
  {
    path: '/pay/bill',
    name: 'bill',
    meta: {
      title: '账单'
    },
    component: () => System.import('@/PagesAreaScan/bill/bill')
  },
  {
    path: '/pay/billDetail',
    name: 'billDetail',
    meta: {
      title: '账单详情'
    },
    component: () => System.import('@/PagesAreaScan/bill/billDetail')
  },
  {
    path: '/relieveWithhold',
    name: 'relieveWithhold',
    meta: {
      title: '解除代扣'
    },
    component: () => System.import('@/PagesAreaScan/CA/relieveWithhold')
  },
  {
    path: '/credit/connectBank',
    name: 'connectBank',
    meta: {
      title: '支付'
    },
    component: () => System.import('@/PagesAreaScan/cashier/connectBank')
  },
  // 预览电子合同
  {
    path: '/CAContract',
    name: 'CAContract',
    meta: {
      title: '电子合同'
    },
    component: () => System.import("@/PagesAreaScan/CA/cAContract")
  },
  // 查看电子合同
  {
    path: '/caContractTerm(.html)?',
    name: 'caContractTerm',
    meta: {
      title: '电子签名使用协议'
    },
    component: () => System.import("@/PagesAreaScan/CA/caContractTerm")
  },
  // 查看电子合同
  {
    path: '/viewerContract',
    name: 'viewerContract',
    meta: {
      title: '电子合同'
    },
    component: () => System.import("@/PagesAreaScan/CA/viewerContract")
  },
  // 签署代扣协议确认
  {
    path: '/signWithhold',
    name: 'signWithhold',
    meta: {
      title: '协议签署中'
    },
    component: () => System.import("@/PagesAreaScan/CA/signWithhold")
  },
  // 自助缴费
  {
    path: '/pay/selfService',
    name: 'selfService',
    meta: {
      title: '添加生活费账单'
    },
    component: () => System.import("@/PagesAreaScan/selfService/selfService")
  },
  // 智能硬件
  {
    path: '/hardware',
    name: 'hardware',
    meta: {
      title: '智能家居'
    },
    component: () => System.import("@/PagesAreaScan/hardware/hardware")
  },
  // 电量状态
  {
    path: '/batteryStatus',
    name: 'batteryStatus',
    meta: {
      title: '电量查询'
    },
    component: () => System.import("@/PagesAreaScan/hardware/batteryStatus")
  },
  {
    path: '/credit/creditStages',
    name: 'creditStages',
    meta: {
      title: '信用租'
    },
    component: () => System.import('@/PagesAreaScan/credit/creditStages')
  },
  {
    path: '/credit/creditOperateLanding',
    name: 'creditOperateLanding',
    meta: {
      title: '信用租'
    },
    component: () => System.import('@/PagesAreaScan/credit/creditOperateLanding')
  },
  {
    path: '/credit/creditResult',
    name: 'creditResult',
    meta: {
      title: '信用租'
    },
    component: () => System.import('@/PagesAreaScan/credit/creditResult')
  },
  {
    path: '/credit/stagesRecord',
    name: 'stagesRecord',
    meta: {
      title: '分期记录'
    },
    component: () => System.import('@/PagesAreaScan/credit/stagesRecord')
  },
  {
    path: '/credit/stagesDetails',
    name: 'stagesDetails',
    meta: {
      title: '分期详情'
    },
    component: () => System.import('@/PagesAreaScan/credit/stagesDetails')
  },
  {
    path: '/credit/repaymentPlan',
    name: 'repaymentPlan',
    meta: {
      title: '还款计划'
    },
    component: () => System.import('@/PagesAreaScan/credit/repaymentPlan')
  },
  {
    path: '/credit/creditAuthorize',
    name: 'creditAuthorize',
    meta: {
      title: '信用租'
    },
    component: () => System.import('@/PagesAreaScan/credit/creditAuthorize')
  },
  {
    path: '/credit/creditFeedback',
    name: 'creditFeedback',
    meta: {
      title: '信用租反馈'
    },
    component: () => System.import('@/PagesAreaScan/credit/creditFeedback')
  },
  {
    path: '(/scan/agree|/can/agree.html)',
    name: 'scanAgree',
    meta: {
      title: '预定须知'
    },
    component: () => System.import('@/PagesAreaScan/lease_new/agree')
  },
  // ------------------------------------ 账务重构路由 start -----------------------------------------------
  // 租约列表，包括二房东租约和经纪人租约
  {
    path: '/pay/leaseList',
    name: 'leaseList',
    meta: {
      title: '租约管理'
    },
    component: () => System.import("@/PagesAreaScan/lease_new/leaseList1")
  },
  // 租约详情
  {
    path: '/pay/leaseDetail',
    name: 'leaseDetail',
    meta: {
      title: '租约详情'
    },
    component: () => System.import("@/PagesAreaScan/lease_new/leaseDetail")
  },
  // 申请退房
  {
    path: '/scan/applyCheckout',
    name: 'applyCheckout',
    meta: {
      title: '申请退房'
    },
    component: () => System.import("@/PagesAreaScan/lease_new/applyCheckout")
  },
  // 资质申请结果确认中
  {
    path: '/scan/applyQualification',
    name: 'applyQualification',
    meta: {
      title: '资质申请结果确认中'
    },
    component: () => System.import('@/PagesAreaScan/lease_new/applyQualification')
  },
  // 签署结果
  {
    path: '/scan/signResult',
    name: 'signResult',
    meta: {
      title: '签署结果'
    },
    component: () => System.import("@/PagesAreaScan/lease_new/signResult")
  },
  {
    path: '/scan/payroll',
    name: 'payroll',
    meta: {
      title: '帮我付款'
    },
    component: () => System.import('@/PagesAreaScan/payroll')
  },
  {
    path: '/scan/scanGuide',
    name: 'scanGuide',
    meta: {
      title: ''
    },
    component: () => System.import("@/PagesAreaScan/scanGuide")
  },
  // 报修列表
  {
    path: '/leaseRepair/repairList',
    name: 'repairList',
    meta: {
      title: '报修服务'
    },
    component: () => System.import("@/PagesAreaScan/repair_new/")
  },
  // 报修添加/编辑
  {
    path: '/leaseRepair/addRepair',
    name: 'addRepair',
    meta: {
      title: '添加报修'
    },
    component: () => System.import("@/PagesAreaScan/repair_new/edit")
  },
  // 报修详情
  {
    path: '/leaseRepair/detail',
    name: 'repairDetail',
    meta: {
      title: '报修详情'
    },
    component: () => System.import("@/PagesAreaScan/repair_new/detail")
  },
  {
    path: '/transferAccounts/',
    name: 'transferAccounts',
    meta: {
      title: "转账支付"
    },
    component: () => System.import("@/PagesAreaScan/transferAccounts/index")
  },
  {
    path: '/transferAccounts/uploadCertificate/',
    name: 'uploadCertificate',
    meta: {
      title: "上传支付凭证"
    },
    component: () => System.import("@/PagesAreaScan/transferAccounts/uploadCertificate")
  },
  {
    path: '/transferAccounts/example/',
    name: 'example',
    meta: {
      title: "样例凭证"
    },
    component: () => System.import("@/PagesAreaScan/transferAccounts/example")
  },
  // 租客问题列表
  {
    path: '/reterQuestions/list',
    name: 'reterQuestionsList',
    meta: {
      title: '其他问题'
    },
    component: () => System.import("@/PagesAreaScan/reterQuestions")
  },
  // 租客问题添加/编辑
  {
    path: '/reterQuestions/add',
    name: 'reterQuestionsAdd',
    meta: {
      title: '添加问题'
    },
    component: () => System.import("@/PagesAreaScan/reterQuestions/edit")
  },
  // 租客问题详情
  {
    path: '/reterQuestions/detail',
    name: 'reterQuestionsDetail',
    meta: {
      title: '问题详情'
    },
    component: () => System.import("@/PagesAreaScan/reterQuestions/detail")
  },
  {
    path: '/questionEnter',
    name: 'questionEnter',
    meta: {
      title: '问题详情'
    },
    component: () => System.import("@/PagesAreaScan/reterQuestions/questionEnter")
  },
  // 租客问题详情
  {
    path: '/reterQuestions/kefuJieru',
    name: 'kefuJieru',
    meta: {
      title: '客服介入'
    },
    component: () => System.import("@/PagesAreaScan/reterQuestions/kefuJieru")
  },
  // 租客问题详情
  {
    path: '/lock',
    name: 'lock',
    meta: {
      title: ''
    },
    component: () => System.import("@/PagesAreaScan/lock")
  },
  // 租客转租
  {
    path: '/lease/addSublet',
    name: 'addSublet',
    meta: {
      title: '转租发房'
    },
    component: () => System.import("@/PagesAreaScan/sublet/addSublet")
  }
];



// WEBPACK FOOTER //
// ./src/router/scan.js